<template>
  <div class="locations">
    <!-- Title and Header -->
    <div class="locations__top">
      <div class="locations__top__title">
        <h2 class="medium-title">
          All Locations
          <span class="span" @click.stop="goToAddNew">Add New</span>
        </h2>
      </div>
    </div>
    <div class="locations__header">
      <div class="locations__header__left">
        <div class="locations__header__left__search">
          <i class="adx-ic_search"></i>
          <input type="text" placeholder="Search location" class="search" v-model="searchBoxValue">
        </div>
        <div class="locations__header__left__filter">
          <adx-dropdown-search @selected="selectedLocation" :list="locations"
              labelButton="Area" :selected-value="selectedLocationValue"/>
          <div v-if="selectedLocations.length > 0" class="locations__header__left__delete">
            <button @click="deleteLocations" class="btn-regular secondary"
            :class="isLoadingDelete ? 'disabled' : ''">
              <span> Delete </span> <adx-loading-spin v-if="isLoadingDelete" />
            </button>
          </div>
        </div>
        <div v-if="selectedLocationValue" class="locations__header__left__filter">
          <button class="btn-small primary" @click="reset">Reset</button>
        </div>
      </div>
      <div class="locations__header__right">
        <p>Sort by :</p>
        <div>
          <adx-dropdown-sort :value.sync="selectedSortValue" :type="true" :options="sort"></adx-dropdown-sort>
        </div>
      </div>
    </div>
    <!-- locations -->
    <div class="locations__content">
      <div>
        <table>
          <thead class="none">
            <tr>
              <td class="header"></td>
              <td class="header">Location</td>
              <td class="header">Devices</td>
              <td class="header">City</td>
              <td class="header">User</td>
            </tr>
          </thead>
          <tbody v-if="!isLoading && !isEmpty">
            <tr v-for="(item, index) in items" :key="index" class="content">
              <td class="image">
                <div class="location__image">
                  <img class="location__image__img" :src="item.image || '/img/notfound/img-placeholder_square.jpg'" alt="">
                </div>
              </td>
              <td class="location">
                <div class="location__item">
                  <div class="location__item__title">{{ item.title }}</div>
                  <div class="location__item__button">
                    <span @click.stop="goToEdit({item})">Edit</span>
                    <span @click.stop="duplicateLocation(item.id)">Duplicate</span>
                  </div>
                </div>
              </td>
              <td class="devices">{{ item.title }}</td>
              <td class="city">{{ item.city_name }}, {{ item.cluster_name }}</td>
              <td class="user">{{ item.owner_email }}</td>
            </tr>
          </tbody>
        </table>
        <!-- Pagination -->
        <div class="pagination" v-if="!isLoading && !isEmpty"><adx-pagination :selectedPage="selectedPage" :maxPage="maxPage" @change-page="selectPage"/></div>
        <!-- Loading State -->
        <div class="loadingState"><adx-loading v-if="isLoading" slot="loading" /></div>
        <!-- Empty State -->
        <div class="emptyState"><adx-empty-selection v-if="isEmpty && !isLoading" /></div>
      </div>
    </div>
  </div>
</template>

<script>
// Components
import SideBar from '@/components/SideBar/Desktop'
import DropdownSort from '@/components/Form/SelectDropdown'
import ListDropdown from '@/components/Dropdown/ListDropdown'
import DropdownSearch from '@/components/Dropdown/SearchDropdown'
import Modal from '@/components/Modal'
import types from '@/lib/types'
import EmptySelection from '@/components/NotFound/Selection'
import Loading from '@/components/Loading/Primary'
import LoadingSpin from '@/components/Loading/Secondary'
import Pagination from '@/components/Pagination'

// Api
import api from '@/api'
import { apiV2 } from '@/api/urls'
import * as validationLib from '@/lib/validation/'
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex';
const {
  helpers,
  validate
} = validationLib

export default {
  name: 'adx-host-locations',
  components: {
    'adx-sidebar': SideBar,
    'adx-dropdown-list': ListDropdown,
    'adx-dropdown-sort': DropdownSort,
    'adx-dropdown-search': DropdownSearch,
    'adx-modal': Modal,
    'adx-empty-selection': EmptySelection,
    'adx-loading': Loading,
    'adx-loading-spin': LoadingSpin,
    'adx-pagination': Pagination,
  },
  data() {
    return {
      selectAll: false,
      isOpen: false,
      sort: [
        {
          'id': 0,
          'label': 'Last Added',
          'value': 'last_added'
        },
        {
          'id': 1,
          'label': 'First Added',
          'value': 'first_added'
        },
      ],
      selectedSortValue: 'last_added',
      selectedLocations: [],
      onClick: false,
      searchBoxValue: '',
      selectedRow: null,
      isInit: true,
      isLoading: false,
      isSubLoading: false,
      isLoadingDelete: false,
      isEmpty: false,
      details: [],
      selectedPage: 1,
      maxPage: 0,
      selectedLocationValue:'',
      items: [],
      locations:[],
    }
  },
  computed: {
    getFilterParams: function () {
      const params = {
        sort_by: this.selectedSortValue || undefined,
        title: this.searchBoxValue || undefined,
        location: this.selectedLocationValue || undefined
      }
      return params
    },
    ...mapGetters({
      user: 'account',
      token: 'token'
    })
  },
  watch: {
    searchBoxValue: helpers.debounce(function () {
      this.$nextTick(function () {
        this.selectedPage = 1
        this.initialLoad()
      })
    }, 500),
    selectedSortValue: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.selectedPage = 1
        this.selectedSortValue = newValue
        this.initialLoad()
      }
    },
    selectedLocationValue: function () {
      this.$nextTick(() => {
        this.initialLoad()
      })
    }
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    
  },
  mounted() {
    if (this.$route.query.page) {
      this.selectedPage = this.$route.query.page
    }
    this.initialLoad()
    this.getFilter()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    initialLoad(isInit = null) {
      (async () => {
        this.isLoading = true
        this.isEmpty = false
        let params = {
          page: this.selectedPage,
          ...this.getFilterParams
        }
        const { data } = await api.get(apiV2.locationList, { needToken: true, params })
        if (!data.count) {
          this.isEmpty = true
        }
        this.items = data.results
        this.maxPage = data.max_page
        
        this.$data.isLoading = false
      })();
    },
    loadCategory() {
      (async () => {
        this.itemsCategory = []
        this.isSubLoading = true
        const searchValue = this.searchValue
        let params = {
          ...this.getFilterParams
        }
        const { data } = await api.get(apiV2.devices, { params })
        this.count = data.count
        this.next = data.next
        this.page = 2
        this.itemsCategory = data.results
        this.isSubLoading = false
        this.totalLocation = this.itemsCategory.length
      })();
    },
    loadData() {
      (async () => {
        this.isPageLoading = true
        const searchValue = this.searchValue
        let params = {
          query: searchValue
        }

        let dataParam = {
          text: searchValue
        }

        let args = {}
        if (this.token) {
          args = { needToken: true }
        }
        const response = await api.post(apiV2.searchHistory, dataParam, args)

        const { data, status } = await api.get(apiV2.search, { params: params })

        const lists = data.lists
        let items = Object.keys(lists).map(function(key, index) {
          return {
            title: key,
            lists: lists[key]
          }
        });
        this.isPageLoading = false

        this.items = items
        this.status = status
        let totalLocation = 0
        this.items.forEach(function (item) {
          totalLocation += item.lists.length
        })
        this.totalLocation = totalLocation
      })();
    },
    deleteLocations(){
      (async () => {
        this.isLoadingDelete = true
        let data = {
          list_id: this.selectedLocations
        }
        const response = await api.patch(apiV2.dashboardHostSchedulesDelete, data, { needToken: true })
        if(response.status == 200) {
          this.items = this.items.filter(value => {
            if(!this.selectedLocations.includes(value.id)) return value
          })
          this.selectedLocations = []
        }
        this.isLoadingDelete = false
      })();
    },
    getFilter () {
      (async () => {
        const categoryName = this.selectedQuickFilterValue
        const { data } = await api.get(apiV2.deviceFilters, {
          params: { category: categoryName }
        })
        this.mapFilter(data)
      })();
    },
    mapFilter (data) {
      this.locations = data.cities
    },
    selectPage(item) {
      this.selectedPage = item
      this.initialLoad()
    },
    selectedLocation(item){
      this.selectedLocationValue = item.id.toString()
      this.$nextTick(() => {
        this.loadCategory()
      });
    },
    toggleCheck(id) {
      if(this.selectedLocations.includes(id)){
        let index = this.selectedLocations.indexOf(id);
        if (index > -1) {
          this.selectedLocations.splice(index, 1);
        }
      } else {
        this.selectedLocations.push(id)
      }

      let incompleteLocations = this.items.filter((locations) => {
        return locations.locations !== 'All Locations'
      })
      if ((this.items.length - incompleteLocations.length) == this.selectedLocations.length) {
        this.selectAll = true
      } else {
        this.selectAll = false
      }
    },
    toggleCheckAllItem() {
      if (this.selectAll) {
        this.unselectAllItem()
      } else {
        this.selectAllItem()
      }
    },
    selectAllItem() {
      this.selectAll = true
      let isAdmin = this.user.groups.includes('grazilla')
      this.selectedLocations = []
      this.items.map(value => {
        if (isAdmin) {
          this.selectedLocations.push(value.id)
        }
      })
    },
    unselectAllItem() {
      this.selectedLocations = []
      this.selectAll = false
    },
    setFilterQuery (query) {
      Object.keys(query).map((index, element) => {
        const variable = types.searchFilter[index]
        this.$data[variable] = ( () => {
          switch (variable) {
            case `selectedSortValue`:
            case `selectedLocationValue`:
            case `searchValue`:
            case `selectedQuickFilterValue`:
            case `selectedSubQuickValue`:
              return query[index]
              break
            default:
              return query[index].split(`,`)
          }
        })()
      })
    },
    goToAddNew() {
      this.$router.push({name: 'addmorelocation'})
    },
    goToEdit({item}) {
      let category = `editlocation`
      if (item.id){
          const {id} = item
          this.$router.push({ name: category, params: { id : id } })
        }
    },
    duplicateLocation(id) {
      (async () => {
        let data = {
          id: id
        }
        const response = await api.post(apiV2.locationAdminDuplicate, data, { needToken: true })
        if(response.status == 200) {
          this.$notify({
            group: 'saved',
            title: 'Success',
            text: `Data successfully duplicated!`,
            type: 'success'
          });
          this.initialLoad()
        } else {
          this.$notify({
            group: 'saved',
            title: 'Error',
            text: response.statusText,
            type: 'danger'
          });
        }
      })();
    },
    selectedLocation(item) {
      this.selectedLocationValue = item.id.toString()
      this.$nextTick(() => {
        this.initialLoad()
      });
    },
    reset() {
      this.selectedLocationValue = null
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
